<template>
  
  <div>
      <AttendCard
        v-for="subattending in $store.state.confirmed_payments"
        :key="subattending.last_subattending.id"
        :subattending="subattending.last_subattending"
        :store="subattending.store"
      />
  </div>


</template>

<script>
import AttendCard from './AttendCard';
  export default {
    components: {   
        AttendCard 
    },
    name: 'ConfirmedPaymentsList',
    created () {      
      this.fetchConfirmedPayments();
    },
    watch: {
      // call again the method if the route changes
      '$route': 'fetchConfirmedPayments'
    },
    methods: {
      fetchConfirmedPayments() {        
        this.$store.dispatch('fetchConfirmedPayments');
      },
      closeDialog() {        
        this.dialog = false
      },
    },
    data () {
      return {
      }
    },
  }
</script>
<style lang="css" scoped>
</style>